/**
 * Parse @mention at the start of a message.
 * Returns { targetRoleId, messageBody } or null.
 */
export function parseMention(content, participants) {
  if (!content.startsWith('@') || participants.length === 0) return null
  const sorted = [...participants].sort((a, b) => b.displayName.length - a.displayName.length)
  for (const p of sorted) {
    const prefix = `@${p.displayName}`
    if (content.startsWith(prefix) && (content.length === prefix.length || content[prefix.length] === ' ')) {
      return { targetRoleId: p.roleId, messageBody: content.slice(prefix.length).trim() }
    }
  }
  return null
}
